module.exports = __webpack_public_path__ + "assets/img/0_02.b44cd340.png";